import React from "react";
import ListMod from "../../../Component/Redesign/ListMod";
import {Datagrid, FunctionField, ShowButton, TextField} from "react-admin";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import {convertedDateWithTime} from "../../../Functions/ConvertedDate";

export const AiQuestionList = () => {
    return <div className="customTableWrap pt-32">
        <ListMod title={'Recent Questions'} actions={false}>
            <Datagrid bulkActionButtons={false}>
                <TextField label='Id' source="id" sortBy="id"/>
                <TextField label='Question' source="name" sortBy="name"/>
                <TextField label='Sources' source="source" sortBy="source"/>
                <TextField label='Tokens' source="tokens" sortBy="tokens"/>
                <TextField label='Cost' source="cost" sortBy="cost"/>
                <FunctionField label="Time" source="created_at" sortBy="created_at" render={(record) => {
                    if (!record.created_at) return <></>;
                    return (convertedDateWithTime(record.created_at));
                }}/>
                <ShowButton label=''  />
            </Datagrid>
        </ListMod>
    </div>
}